import React from "react";
import { StyledPopUpBox, StyledBox } from "../../styles/devices/Container";
import { StyledRow } from "../../styles/Row";
import { StyledEditActionContainer } from "../../styles/devices/Container"; 
import { StandardButton } from "./Buttons";
import { messages_common } from "../../types/Messages";

export function WarningPopUp ({handleClose}) {

    return (
        <StyledPopUpBox>
            <StyledBox>
                <StyledRow>
                    {messages_common.overlap_warning}
                </StyledRow>
                <StyledRow>  
                    <StyledEditActionContainer>                 
                        <StandardButton background='#FFFFFF' onClick={handleClose} text="Ok"/>
                    </StyledEditActionContainer>        
                </StyledRow>      
            </StyledBox>
        </StyledPopUpBox>
    )
}

